// extracted by mini-css-extract-plugin
export default {"card":"y4-z","carouselContainer":"z4-z","carouselContent":"A4-z"};